import hostedzones from './hostedzones';

export default {
    namespaced: true,
    modules: {
        hostedzones,
    }
}